export default "__VITE_ASSET__DYFjVm3O__ 1200w";